import Comments from './Comments.container';

export default Comments;
